import { canMarkInvoiceAsBilled } from './markInvoiceAsBilledEligibility';
import { isManagedInvoiceStatus } from './invoiceStatusPresentation';

export const MARK_AS_PAID_ACTION_ID = 'invoiceAction-markAsPaid';
export const MARK_AS_BILLED_ACTION_ID = 'invoiceAction-markAsBilled';

export function getInvoiceRowActionAvailability({
  actionId,
  status,
  invoiceDate,
  hasPermission,
  isBilledStatusEnabled,
}: {
  actionId?: string;
  status: string;
  invoiceDate?: Date | string | null;
  hasPermission: boolean;
  isBilledStatusEnabled: boolean;
}): { isVisible: boolean; disabledReasonKey?: string } {
  if (actionId === MARK_AS_BILLED_ACTION_ID) {
    const { isVisible, isEnabled } = canMarkInvoiceAsBilled({
      status,
      invoiceDate,
      hasPermission,
    });

    return {
      isVisible,
      disabledReasonKey:
        isVisible && !isEnabled
          ? 'abp.invoice.markAsBilledNotYetAvailable'
          : undefined,
    };
  }

  const isMarkAsPaidHidden =
    actionId === MARK_AS_PAID_ACTION_ID &&
    isBilledStatusEnabled &&
    isManagedInvoiceStatus(status, true);

  return { isVisible: !isMarkAsPaidHidden };
}
